export const GET_EXTRACTS = 'GET_EXTRACTS';
